import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex flex-col mt-4 gap-y-3" }
const _hoisted_2 = { class: "w-full bg-primary-color-50 text-primary-color-800 text-xs leading-4 font-semibold uppercase py-1 px-2 rounded-md" }
const _hoisted_3 = ["onClick"]

import { computed, ref } from "vue"
import { SearchIcon } from "@heroicons/vue/outline"
import { useWorkflowStore } from "@/stores/workflow"
import { convertTriggerEvent } from "@/shared/utils/helpers"
import GgmsInput from "@/components/GgmsInput.vue"
import TriggerNode from "@/components/workflows/TriggerNode.vue"
import TriggerCard from "@/components/workflows/TriggerCard.vue"
import { ListingActivityTriggerNodeType, TriggerNodeType } from "@/shared/models/workflow"
import PageVisitedFilterTriggerSidebar from "./PageVisitedFilterTriggerSidebar.vue"

interface Props {
    modelValue: boolean
}

export default /*@__PURE__*/_defineComponent({
  __name: 'CMSListingActivityTriggerSidebar',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "changeAction"],
  setup(__props: any, { emit: __emit }) {

const workflowStore = useWorkflowStore()

const searchTerm = ref("")
const eventsCategories = ["appointment", "event"]

const events = [
    {
        title: ListingActivityTriggerNodeType.appointmentCreated,
        example: "Fires when a buyer or seller books a showing/meeting and a specific team member IS assigned.",
        type: "appointment",
    },
    {
        title: ListingActivityTriggerNodeType.appointmentCreatedAgency,
        example: "Fires when a buyer or seller books a showing/meeting and a specific team member IS NOT assigned.",
        type: "appointment",
    },
    {
        title: ListingActivityTriggerNodeType.pageVisited,
        example: "Triggers when a contact loads or navigates to a specified page or URL on your site.",
        type: "event",
    },
    {
        title: ListingActivityTriggerNodeType.requestForInformation,
        example: "Triggers when a contact submits a “Request Info” form on any listing.",
        type: "event",
    },
    {
        title: ListingActivityTriggerNodeType.showingRequest,
        example: "Triggers when a contact schedules or attempts to schedule a property showing.",
        type: "event",
    },
    {
        title: ListingActivityTriggerNodeType.saveListing,
        example: "Triggers when a contact adds a listing to their Saved collection.",
        type: "event",
    },
    {
        title: ListingActivityTriggerNodeType.favoriteListing,
        example: "Triggers when a contact adds a listing to their Favorites collection.",
        type: "event",
    },
    {
        title: ListingActivityTriggerNodeType.hideListing,
        example: "Triggers when a contact hides or dismisses a listing from their search results.",
        type: "event",
    },
]

const filteredEvents = computed(() =>
    events.filter((event) => convertTriggerEvent(event.title).toLowerCase().includes(searchTerm.value.toLowerCase()))
)



const emit = __emit

function chooseEvent(event: string) {
    workflowStore.modelValue = event
    if (event === ListingActivityTriggerNodeType.pageVisited) {
        emit("changeAction", { componentName: PageVisitedFilterTriggerSidebar.__name })
        return
    }
    emit("changeAction", { componentName: TriggerNode.__name, node: TriggerNodeType.listingActivity })
    workflowStore.setHeaderText()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(GgmsInput, {
      modelValue: searchTerm.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event)),
      iconStart: _unref(SearchIcon),
      placeholder: "Search"
    }, null, 8, ["modelValue", "iconStart"]),
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(eventsCategories, (category) => {
      return _createElementVNode("div", { key: category }, [
        _withDirectives(_createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(category), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredEvents.value.filter((ev) => ev.type === category), (event) => {
            return (_openBlock(), _createElementBlock("div", {
              key: event,
              class: "text-gray-900 text-base leading-6 font-medium cursor-pointer",
              onClick: ($event: any) => (chooseEvent(event.title))
            }, [
              _createVNode(TriggerCard, {
                title: _unref(convertTriggerEvent)(event.title),
                example: event.example,
                onClick: ($event: any) => (chooseEvent(event.title))
              }, null, 8, ["title", "example", "onClick"])
            ], 8, _hoisted_3))
          }), 128))
        ], 512), [
          [_vShow, filteredEvents.value.filter((ev) => ev.type === category).length]
        ])
      ])
    }), 64))
  ], 64))
}
}

})